import { render } from "./DialogBox.vue?vue&type=template&id=77ac9169&scoped=true&ts=true"
import script from "./DialogBox.vue?vue&type=script&lang=ts"
export * from "./DialogBox.vue?vue&type=script&lang=ts"

import "./DialogBox.vue?vue&type=style&index=0&id=77ac9169&lang=scss&scoped=true"

import exportComponent from "/Users/hirosuke-pi/projects/vr-jmof-front-2020/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77ac9169"]])

export default __exports__